import { Component, OnInit, Query } from '@angular/core';
import { FirestoreService } from 'src/app/core/services/firestore.service';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { photos } from 'src/app/core/interfaces/photos';
import { Observable, BehaviorSubject, observable } from 'rxjs';
import { combineLatest, map, combineAll } from 'rxjs/operators';
import { BaseArtWork } from 'src/app/core/interfaces/base-artwork';
import { ArtworkTypes } from 'src/app/core/interfaces/artwork-types';



@Component({
  selector: 'app-gallerysidenav',
  templateUrl: './gallerysidenav.component.html',
  styleUrls: ['./gallerysidenav.component.scss']
})
  export class GallerysidenavComponent {



  constructor() {
  }


}